/* 合法uri*/
export function validateURL(textval) {
  const urlregex = /^(https?|ftp):\/\/([a-zA-Z0-9.-]+(:[a-zA-Z0-9.&%$-]+)*@)*((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9][0-9]?)(\.(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9]?[0-9])){3}|([a-zA-Z0-9-]+\.)*[a-zA-Z0-9-]+\.(com|edu|gov|int|mil|net|org|biz|arpa|info|name|pro|aero|coop|museum|[a-zA-Z]{2}))(:[0-9]+)*(\/($|[a-zA-Z0-9.,?'\\+&%$#=~_-]+))*$/
  return urlregex.test(textval)
}

/* 小写字母*/
export function validateLowerCase(str) {
  const reg = /^[a-z]+$/
  return reg.test(str)
}

/* 大写字母*/
export function validateUpperCase(str) {
  const reg = /^[A-Z]+$/
  return reg.test(str)
}

/* 大小写字母*/
export function validateAlphabets(str) {
  const reg = /^[A-Za-z]+$/
  return reg.test(str)
}
/* 密码  */
export function validatePwd(str) {
  // 数字+字母；字数字+字母+特殊字符 8-20位
  // const reg = /^(?=.*[A-Za-z])(?=.*\d)(?![\d]+$)(?![a-zA-Z]+$)(?![^\da-zA-Z]+$).{8,20}$/
  // 数字+字母；字数字+字母+个别特殊字符 8-20位
  const reg = /^(?=.*[a-zA-Z])(?=.*\d)[a-zA-Z0-9!@#$%^&+]{8,20}$/
  return reg.test(str)
}

/* 正整数 */
export function validateInteger(str) {
  const reg = /^[0-9]*[1-9][0-9]*$/
  return reg.test(str)
}
/* 中文英文数字 标点符号 */
export function validateChinese(str) {
  // const reg = /^[^\x00-\xff]+([A-Za-z0-9])*$/
  // 注意减号
  const reg = /^[a-zA-Z0-9-_?;:!，。：；、？！……——\.\【\】\{\}\（\）\(\)\‘\’\“\”\《\》\<\>\u4e00-\u9fa5]+$/
  return reg.test(str)
}
/* 中文名字 */
export function validateName(str) {
  const reg = /^[\u4e00-\u9fa5]+(·[\u4e00-\u9fa5]+)*$/
  return reg.test(str)
}
/* 中文英文名字 中间\s空格*/
export function validatetypeName(str) {
  // const reg = /^[\u4e00-\u9fa5a-zA-Z·\s]+$/
  // const reg = /^[\u4e00-\u9fa5a]|(^[a-zA-Z]+[\s.]?([a-zA-Z]+[\s.]?)[a-zA-Z])+$/
  // const reg = /^\S[a-zA-Z\s\d\u4e00-\u9fa5]+\S$/
  const reg = /^(?:[\u4e00-\u9fa5]+)(?:·[\u4e00-\u9fa5]+)*$|^[a-zA-Z]+\s?[\.·\-()a-zA-Z]*[a-zA-Z]+$/
  return reg.test(str)
}

/* 中英文验证 中英文可同时存在*/
export function validateZhAndEn(str) {
  const reg = /^[a-zA-Z|\u4e00-\u9fa5]+$/
  return reg.test(str)
}

/**
 * validate email
 * @param email
 * @returns {boolean}
 */
export function validateEmail(email) {
  const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  return re.test(email)
}

/**
 * 手机号验证
 * @param mobile
 * @returns {boolean}
 */
export function validMobile(mobile) {
  const re = /^1[3|4|5|6|7|8|9][0-9]\d{8}$/
  return re.test(mobile)
}

/**
 * 电话号码验证
 * @param mobile
 * @returns {boolean}
 */
export function validPhone(phone) {
  const re = /0\d{2,3}-\d{7,8}/
  return re.test(phone)
}

/**校验密码：只能输入6-12个字母、数字、下划线*/
export function isPasswd(s) {
  const re = /^(\w){6,12}$/
  return re.test(s)
}

/**
 * 验证数字
 * @param str
 * @returns {boolean}
 */
export function validNum(str) {
  var re = new RegExp('^[0-9]*$')
  return re.test(str)
}

// 表单验证手机号
export function checkMobile(rule, value, callback) {
  if (!value) {
    return callback(new Error("必填"));
  }
  if (!validMobile(value)) {
    return callback(new Error("格式不对"));
  }
  callback();
};
// 表单验证滑块
export function checkSlider(rule, value, callback) {
  if (!value) {
    return callback(new Error("拖动滑块到最右侧"));
  }
  callback();
};
// 表单验证手机验证码
export function checkVerCode(rule, value, callback) {
  if (!value) {
    return callback(new Error("必填"));
  }
  if (!validNum(value)) {
    return callback(new Error("格式不对"));
  }
  callback();
};